



































import Component from 'vue-class-component'
import {Prop} from "vue-property-decorator";
import BasicComponent from "@/global/BasicComponent";
import {ImageApi, ImageDto, ImageOrientationDto} from "@swagger";

@Component({
  components: {}
})
export default class ImagePreview extends BasicComponent {

  @Prop(Object) readonly image!: ImageDto;
  @Prop(String) readonly filter: string;
  @Prop(Boolean) readonly doNotOpenOnClick!: boolean;
  @Prop(String) readonly smallHeight: string;
  @Prop(String) readonly smallWidth: string;
  @Prop(Boolean) readonly hasPreviousPreview: boolean; // When using as a slider
  @Prop(Boolean) readonly hasNextPreview: boolean;
  /**
   * The component allows to toggle the favorite state
   */
  @Prop({
    type: Boolean,
    default: true
  }) readonly favoriteEditable: boolean;
  @Prop({
    type: Boolean,
    default: true
  }) readonly showFavoriteIcon: boolean;

  dialog: boolean = false;
  smallLoaded: boolean = false;
  largeLoaded: boolean = false;
  mayLoadLargeImage: boolean = false;

  created() {
    const _this = this;
    document.addEventListener('keyup', function (evt) {
      let cancel = false;
      if (evt.keyCode === 37 && _this.dialog) { // Arrow left
        _this.openPrevious();
        cancel = true;
      } else if (evt.keyCode === 39 && _this.dialog) { // Arrow right
        _this.openNext();
        cancel = true;
      }
      if (cancel) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
      }
    });
  }

  mounted() {
  }

  onImageClick() {
    this.$emit("select_image");
    if (this.doNotOpenOnClick) return;
    this.openDialog();
  }

  getFavoriteIconName(image: ImageDto): string {
    return image.favorite ? "favorite" : "favorite_border";
  }

  openDialog() {
    this.dialog = true;
    this.trackEvent("Bild", "Vergrößerte Ansicht", undefined, this.image?.uniqueId);
  }

  closeDialog() {
    this.dialog = false;
  }

  openPrevious() {
    if (!this.dialog) return;
    this.closeDialog();
    this.$emit("openPrevious");
  }

  openNext() {
    if (!this.dialog) return;
    this.closeDialog();
    this.$emit("openNext");
  }

  largeImageWidth() {
    if (!this.$refs.large) return this.getSmallWidth;
    return this.$refs.large["image"]["naturalWidth"];
  }

  onSmallLoaded() {
    this.smallLoaded = true;
    this.$emit("small-loaded");
    const data = this;
    this.$nextTick(() => {
      this.$refs.small["ondragstart"] = () => false;
    });
    setTimeout(() => {
      data.mayLoadLargeImage = true;
    }, 5 * 1000);
  }

  onLargeLoaded() {
    this.largeLoaded = true;
    this.$emit("large-loaded");
    this.$nextTick(() => {
      this.$refs.large["ondragstart"] = () => false;
    });
  }

  toggleFavorite(image: ImageDto, evt: MouseEvent) {
    if (!this.favoriteEditable) {
      this.onImageClick();
      return;
    }
    if (image.favorite) {
      this.$set(image, "favorite", false);
      new ImageApi(this.apiConfiguration).removeFavoriteImage(image.uniqueId)
          .then(() => {
            this.trackEvent("Bild", "Defavorisieren", undefined, image.uniqueId);
          })
          .catch((err) => {
            console.error(err);
          });
    } else {
      this.$set(image, "favorite", true);
      new ImageApi(this.apiConfiguration).addFavoriteImage(image.uniqueId)
          .then(() => {
            this.trackEvent("Bild", "Favorisieren", undefined, image.uniqueId);
          })
          .catch((err) => {
            console.error(err);
          });
    }
  }

  get smallImageUrl() {
    return this.getImageUrl(this.image?.smallUrl, this.filter);
  }

  get largeImageUrl() {
    return this.getImageUrl(this.image?.largeUrl, this.filter);
  }

  get displayId() {
    return this.image?.label;
  }

  get landscape() {
    return this.image?.orientation === ImageOrientationDto.LANDSCAPE;
  }

  get getSmallHeight() {
    if (this.smallHeight) return this.smallHeight;
    return this.landscape ? "92px" : "128px";
  }

  get getSmallWidth() {
    if (this.smallWidth) return this.smallWidth;
    return this.landscape ? "128px" : "92px";
  }

  get largeImageMaxHeight() {
    if (this.largeLoaded) {
      return "90vh";
    }
    return this.getSmallHeight;
  }

  get displayFavoriteIcon(): boolean {
    return this.showFavoriteIcon && (this.favoriteEditable || (this.image?.favorite || false))
  }

}

